export default function IframePdf({ url }: { url: string }) {
    return (
        <iframe
            src={url}       
            style={{ width: '100%', height: '90vh', border: 0 }}
            title="PDF"
        />
    );
}
